import { Component, OnInit, Input } from '@angular/core';
import { BehaviorModelChangeService } from 'src/app/service/behavior-model-change.service.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth/auth.service';

@Component({
  selector: 'app-site-side-menu',
  templateUrl: './site-side-menu.component.html',
  styleUrls: ['./site-side-menu.component.css']
})
export class SiteSideMenuComponent implements OnInit {
  @Input('loginUserData') public loginUserData;
  photoUrl='';
  constructor(private authService:AuthService,private router:Router,private behaviorModelChangeService:BehaviorModelChangeService) { }

  ngOnInit() {
    this.behaviorModelChangeService.userPicture.subscribe(data=>{
        this.photoUrl=data;
    });
  }
  isPostgraduateStudent(){
    return this.loginUserData.ApplicationTypeId==7 || this.loginUserData.ApplicationTypeId==8;
  }


  onLogOut(e){
    e.preventDefault()

    this.authService.logout();
    this.router.navigate(['/account/login']);

  }

}
